export default __webpack_public_path__ + "static/media/edit.57400259.svg";